import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

import { PromoCode } from '../interfaces/promoCode';

@Injectable({
  providedIn: 'root',
})
export class PromocodeService {
  private apiUrl = `${environment.Server_URL}/promo-codes`;

  constructor(private http: HttpClient) {}

  // ✅ Get all promo codes
  getAll(): Observable<PromoCode[]> {
    return this.http.get<PromoCode[]>(this.apiUrl);
  }

  // ✅ Get single promo code
  getById(id: number): Observable<PromoCode> {
    return this.http.get<PromoCode>(`${this.apiUrl}/${id}`);
  }

  // ✅ Create new promo code
  create(promo: PromoCode): Observable<PromoCode> {
    return this.http.post<PromoCode>(this.apiUrl, promo);
  }

  // ✅ Update existing promo code
  update(id: number, promo: PromoCode): Observable<PromoCode> {
    return this.http.put<PromoCode>(`${this.apiUrl}/${id}`, promo);
  }

  // ✅ Delete promo code
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
